import React from "react";
import { Link } from "react-router-dom";
import { FAQ_ITEMS } from "../../seo/faqContent.js";
import { FaqSection, SeoHero, TextSection } from "./SeoPageBlocks";

const nextStepLinks = [
  { to: "/register-group", label: "Registrera er grupp" },
  { to: "/sa-fungerar-salespartner", label: "Så fungerar SalesPartner" },
  { to: "/contact", label: "Kontakta oss" },
];

export default function VanligaFragorPage() {
  return (
    <div className="bg-slate-50">
      <SeoHero
        eyebrow="Frågor och svar"
        title="Vanliga frågor om SalesPartner"
        description="Korta svar om registrering, försäljning, betalning, leverans och gruppens förtjänst. Fördjupning finns på de sidor som äger respektive fråga."
        primaryCtaLabel="Registrera er grupp"
        primaryCtaTo="/register-group"
        secondaryCtaLabel="Så fungerar SalesPartner"
        secondaryCtaTo="/sa-fungerar-salespartner"
      />

      <FaqSection
        title="Svar på vanliga frågor"
        description="Korta svar först. Vill du läsa mer finns en länk till rätt sida."
        items={FAQ_ITEMS}
      />

      <p className="max-w-6xl mx-auto px-4 py-6 text-slate-700">Planerar ni klassresa? <Link className="underline font-semibold" to="/tjana-pengar-till-klassresan">Läs guiden</Link>.</p>
      <TextSection
        eyebrow="Nästa steg"
        title="Fortsätt härifrån"
        intro="Registrera gruppen, läs hur flödet fungerar eller kontakta oss om ni behöver mer stöd."
      >
        <div className="grid sm:grid-cols-3 gap-4">
          {nextStepLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-5 font-medium text-slate-800 transition hover:border-amber-300 hover:bg-white hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </TextSection>
    </div>
  );
}
